module.exports = __webpack_public_path__ + "./img/bannerNRF.e6260a7dac0cec24527d258583ce0ee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/bannerNRF.jpg
// module id = ./src/assets/img/slider/bannerNRF.jpg
// module chunks = 14